import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function Icon(props) {
    const { icon, size } = props;
    return (
    // @ts-ignore
    _jsx(FontAwesomeIcon, { icon: `fa-solid fa-${icon}`, size: size }));
}
export default Icon;
